// extracted by mini-css-extract-plugin
export var active = "_31-7";
export var container = "_31-0";
export var evenWidth = "_31-4";
export var large = "_31-5";
export var outlet = "_31-8";
export var slide = "_31-2";
export var small = "_31-6";
export var tab = "_31-3";
export var tabs = "_31-1";